<div class="flex timing-container">
	<vb-lxp-timing-tower-full
		class="grow-1"
		[activeClass]="'active-tower-item'"
		[selectedClasses]="selectedClasses()"
	></vb-lxp-timing-tower-full>
	<vb-lxp-panel
		[panelKey]="'map'"
		[defaultOpenState]="true"
		[panelClass]="'map-panel'"
		[panelHeaderClass]="'map-panel-header'"
		[panelBodyClass]="'block h-full'"
		[disablePin]="true"
	>
		<div header class="pr-14">
			<span>Sebring Track Map</span>
			<button
				class="border-1 border-border-default p-2 rounded ml-2 cursor-pointer hover:bg-surface-container-high"
				(click)="openFullMapPage()"
				target="_blank"
				[title]="'Full Map'"
			>
				<i class="bi bi-arrows-fullscreen"></i>
			</button>
		</div>
		<div body class="h-full">
			<vb-lxp-map
				[showLabels]="false"
				[track]="'sebring_track.geojson'"
				[selectedCarIds]="timingTowerService.activeList()"
			></vb-lxp-map>
		</div>
	</vb-lxp-panel>
</div>
